import React, {useEffect} from 'react';
import {CButton, CButtonGroup} from "@coreui/react";

const CurrentBalance = (props) => {
    return <>
        <CButtonGroup role="group" size={'sm'} aria-label="Basic mixed styles example"
                      className={'p-1'}
        >
            {
                props.data.customer_ledger_latest !== undefined &&
                props.data.customer_ledger_latest &&
                props.data.customer_ledger_latest.current_balance !== undefined &&
                <>
                    <CButton color="info" disabled={true}>
                        Balance
                    </CButton>
                    <CButton color="primary" disabled={true}>
                        {props.data.customer_ledger_latest.current_balance}
                    </CButton>
                </>
            }
            {props.children}
        </CButtonGroup>
    </>;
}

export default CurrentBalance;
